import * as style from "./PoiosBackground.module.css";

const PoiosBackground = () => <img src={"/media/poios_background.jpg"} alt="" className={style["img"]} />;

export default PoiosBackground;
